/**
 * Company: SPHMedia
 * Description: Unverified banner that has a fixed position at the top of the screen
 */

import { ReactElement, useState } from "react";
import Button from "@src/app/components/AccessibleComponents/Button";
import { mySPHOpenResendVerificationMail } from "@src/app/util/helpers";
import cx from "classnames";

import Icon from "../Icon/Icon";

import styles from "./UnverifiedBanner.module.scss";

type UnverifiedBannerProps = {
  email: string;
};

/**
 * UnverifiedBanner
 * Description: Unverified banner that is displayed when a user is not verified
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function UnverifiedBanner({
  email = "",
}: UnverifiedBannerProps): ReactElement {
  const [visible, setVisible] = useState(true);

  const removeComponent = () => {
    setVisible((prev) => !prev);
  };

  return (
    <>
      {visible ? (
        <div className="mb-4 bg-gray-900 py-4 text-center text-white">
          <div className="grid grid-cols-12 place-content-center gap-3">
            <div className="col-span-11 flex flex-wrap gap-3 justify-self-center">
              <div className="flex-auto">
                <p className="mb-0 font-poppins">
                  {/* TODO: change to use Icon component instead */}
                  <svg
                    className="svg-inline--fa fa-bell mr-3 text-red"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="bell"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M256 32V51.2C329 66.03 384 130.6 384 208V226.8C384 273.9 401.3 319.2 432.5 354.4L439.9 362.7C448.3 372.2 450.4 385.6 445.2 397.1C440 408.6 428.6 416 416 416H32C19.4 416 7.971 408.6 2.809 397.1C-2.353 385.6-.2883 372.2 8.084 362.7L15.5 354.4C46.74 319.2 64 273.9 64 226.8V208C64 130.6 118.1 66.03 192 51.2V32C192 14.33 206.3 0 224 0C241.7 0 256 14.33 256 32H256zM224 512C207 512 190.7 505.3 178.7 493.3C166.7 481.3 160 464.1 160 448H288C288 464.1 281.3 481.3 269.3 493.3C257.3 505.3 240.1 512 224 512z"
                    ></path>
                  </svg>
                  Hello, your email is unverified. Please confirm{" "}
                  <strong>{email}</strong> for acess to all your SPH accounts.
                </p>
              </div>
              <div className="flex-auto">
                <span id="sph_user_name" className="hidden">
                  {encodeURI(email)}
                </span>
                <Button
                  className={cx(
                    "font-poppins text-3xs font-bold uppercase",
                    styles.verificationButton
                  )}
                  onPress={() => {
                    mySPHOpenResendVerificationMail();
                  }}
                >
                  Resend Verification Email
                </Button>
              </div>
            </div>
            <div className="flex h-full items-center justify-center place-self-end">
              <Button
                onPress={() => {
                  removeComponent();
                }}
              >
                <Icon type="close" size={30} />
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
